
/**
 * SVG representation of the BitBucket logo (in color).
 */
const AuthLoginMethodLogoBitBucket = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" role="img" aria-hidden="true">
    <path
      fill="#2684FF"
      d="M6.77 7.2a.77.77 0 00-.77.9l3.26 19.8a1.05 1.05 0 001.03.88h15.66a.77.77 0 00.77-.65L29.98 8.1a.77.77 0 00-.77-.9H6.77zM20.5 21.53h-5l-1.35-7.08h7.57l-1.22 7.08z"
    />
    <path
      fill="url(#paint0_linear)"
      d="M28.94 14.45h-7.21l-1.22 7.08h-5l-5.9 7c.2.16.43.25.68.25h15.66a.77.77 0 00.77-.64l2.22-13.69z"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="30.61"
        x2="18.68"
        y1="16.43"
        y2="25.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.18" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default AuthLoginMethodLogoBitBucket;
